import React from 'react'

import {
  InlineEditor
} from '../../../components/inline-editor'

import Navigation from '../../../components/navigation'

export default () => (
  <section>
    <header>
      <h1>Inline Editor</h1>
    </header>
    <InlineEditor />
    <Navigation />
  </section>
)



/** WEBPACK FOOTER **
 ** ./pub/client/routes/IndexPage/InlineEditor/index.js
 **/